import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  drawerOpen: boolean;
  listado: boolean;
}

const initialState: UIState = {
  drawerOpen: true,
  listado: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleDrawer(state) {
      state.drawerOpen = !state.drawerOpen;
    },
    setDrawerOpen(state, action: PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
    },
    setListado(state, action: PayloadAction<boolean>) {
      state.listado = action.payload;
    },
  },
});

export const { toggleDrawer, setDrawerOpen, setListado } = uiSlice.actions;
export default uiSlice.reducer;
